export default "<nav class=\"menu-list\">\n  <menu-list [menuList]=\"menuList\"></menu-list>\n</nav>\n";